<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" persistent :max-width="step === 0? '400px': '500px'" scrollable)
      v-card
        v-card-title.px-4(:style="{ 'background-color' : steps[step].color }")
          v-col.pa-0.pb-2
            .h6.textColor--text.mt-1(:class="steps[step].text ? steps[step].text : 'basic800--text' ") {{ steps[step].title }}
            .p2.mt-1(:class="steps[step].text ? steps[step].text : 'basic700--text' ") {{ steps[step].description }}
        v-divider(v-if="step > 0" :class="steps[step].divider")

        v-card-text.pa-0
          v-window(v-model="step")

            v-window-item.px-4(:value="0")
              v-container.px-0
                .p1.primary500--text Yezza Books is the accounting app that saves your business money and time

                .p1.primary500--text.mt-4 Let us walk you through our main features.

            v-window-item.px-4(:value="1")
              div.mt-3
                .p1.primary500--text To record sales made, click the
                  b  “Record Income”
                  span  button on your home page.
                
                v-card(flat)
                  v-img.my-4(:src="require('@/assets/images/books/books_walkthrough_1.png')" contain)
                
                v-row.d-flex.my-4
                  v-spacer
                  v-icon(size="10" color="info300") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-spacer

            v-window-item(:value="2")
              v-container.pa-0
                .pa-4(:style="{'background-color': steps[step].color }")
                  .label.basic600--text.text-uppercase income amount
                  v-card.mt-2(flat)
                    v-layout.pa-4(@click="openCalculatorInputIncomeDialog = true")
                      div.mr-4.my-auto(style="height:24px")
                        CashIcon(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
                      .h6.primary500--text {{ form.income.value | displayPrice }}
                v-form.pa-4(ref="form")
                  .label.basic600--text.text-uppercase Description
                  v-text-field.mt-2(v-model='form.income.description' background-color="basic200" height="40" outlined dense placeholder="Write a description")

                  .label.basic600--text.text-uppercase(id="formDataDate") Date
                  v-dialog(v-model='form.income.date.show' width='290px')
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(:value="form.income.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                        template(v-slot:append)
                          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                    v-date-picker(v-model='form.income.record_date' color="primary" no-title @change="saveIncomeDate()")


            v-window-item.px-4(:value="3")
              div.mt-3
                .p1.primary500--text To record expenses, click the
                  b  “Record Expense”
                  span  button on your home page.

                v-card(flat)
                  v-img.my-4(:src="require('@/assets/images/books/books_walkthrough_2.png')" contain)
                
                v-row.d-flex.my-4
                  v-spacer
                  v-icon(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="info300") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-spacer

            v-window-item(:value="4")
              v-container.pa-0
                .pa-4(:style="{'background-color': steps[step].color }")
                  .label.basic100--text.text-uppercase expense amount
                  v-card.mt-2(flat)
                    v-layout.pa-4(@click="openCalculatorInputExpenseDialog = true")
                      div.mr-4.my-auto(style="height:24px")
                        CashIcon(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
                      .h6.primary500--text {{ form.expense.value | displayPrice }}
                v-form.pa-4(ref="form")
                
                  .label.basic600--text.text-uppercase(id="formDataDate") Date
                  v-dialog(v-model='form.expense.date.show' width='290px')
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(:value="form.expense.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                        template(v-slot:append)
                          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                    v-date-picker(v-model='form.expense.record_date' color="primary" no-title @change="saveExpenseDate()")

                  .label.basic600--text.text-uppercase(id="formDataCategory") Category (Required)
                  v-select.mt-2(v-model="form.expense.category" item-text="name" item-value="id" :items="categories" outlined dense background-color="basic200" placeholder="Select expense category" :rules="rules.is_selected" return-object :loading="isFetchingCategories")
                    template(v-slot:append)
                      eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

                    template(v-slot:item="{ index, item, attrs }")
                      v-layout
                        v-list-item-content
                          v-list-item-title.s1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
                          v-list-item-subtitle.c1(v-if="item.description" :class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.description }}
                  
                  .label.basic600--text.text-uppercase Description
                  v-text-field.mt-2(v-model='form.expense.description' background-color="basic200" height="40" outlined dense placeholder="Write a description")

            v-window-item.px-4(:value="5")
              div.mt-3(v-show="!openSaveDialog")
                .p1.primary500--text Profit made will appear on your home page. Filter the date range to view profit or loss at a specific time period.
                
                v-card.mx-4.mt-4.py-1
                  div.text-center.mt-4
                    v-row.d-flex.align-center(no-gutters)
                      v-col.shrink
                        v-btn.my-auto.mr-2(color="primary400" text height=32 x-small disabled)
                          eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="12")
                          .label.ml-n1.basic100--text Filter
                      v-col
                        .s1.primary500--text Profit & Loss
                      v-col.shrink
                        v-btn.my-auto.mr-2(color="primary400" text height=32 x-small disabled)
                          eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="12")
                          .label.ml-n1.primary400--text Filter
                    .h5 
                      span.danger500--text(v-if="totalProfitLoss < 0") {{ totalProfitLoss | displayPrice }}
                      span.success500--text(v-else-if="totalProfitLoss > 0") {{ totalProfitLoss | displayPrice }}
                      span(v-else) {{ totalProfitLoss | displayPrice }}
                    .c2.textColorHint--text This month
                    
                  v-card.ma-4.pa-2(flat outlined max-width="480px" style="border: 1px solid var(--v-primary200);")
                    v-row(no-gutters)
                      v-col(align="center")
                        .p2.my-1 Income
                        .s1.mb-1 {{ form.income.value | displayPrice }}
                      v-divider.basic300(vertical)
                      v-col(align="center")
                        .p2.my-1 Expense
                        .s1.mb-1 {{ form.expense.value | displayPrice }}
                
                v-row.d-flex.my-4
                  v-spacer
                  v-icon(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="info300") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-spacer
                
                .p1.primary500--text.mb-4 Click on
                  b  “Reports”
                  span  in the side menu to view your profit & loss report in detail.
              
            v-window-item.px-4(:value="6")
              div.mt-5
                .p1.primary500--text You are now ready to manage your business better.
                .s1.mt-4 To know about:
                .s1.primary400--text.mt-2 1. Creating invoice
                .s1.primary400--text.mt-2 2. Reminder scheduling
                .s1.primary400--text.mt-2 3. Bulk transaction upload
                .s1.mt-2 click on the Help Centre icon on the top bar or the side menu.
                
                v-card(flat)
                  v-img.my-4.mt-6(:src="require('@/assets/images/books/books_walkthrough_4.png')" contain)
                
                v-row.d-flex.my-4
                  v-spacer
                  v-icon(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="basic400") mdi-circle
                  v-icon.ml-1(size="10" color="info300") mdi-circle
                  v-spacer

        v-card-actions
          v-spacer
          v-btn(v-if="steps[step].secondary" color="white" text @click="previous()" depressed height=32) 
            .button-Aa-small.primary400--text {{ steps[step].secondary }}
          v-btn(v-if="steps[step].primary" color="info500" dark @click="nextStep()" depressed height=32) 
            .button-Aa-small.basic100--text {{ steps[step].primary }}

    .modals
      CalculatorInput(v-if="openCalculatorInputIncomeDialog" :open.sync="openCalculatorInputIncomeDialog" :initial="form.income.value" @input="handleInputIncome")
      CalculatorInput(v-if="openCalculatorInputExpenseDialog" :open.sync="openCalculatorInputExpenseDialog" :initial="form.expense.value" @input="handleInputExpense")
      y-dialog(fill-height fluid v-model="openSaveDialog" transition="fade-transition" persistent max-width="500px" scrollable)
        v-card.text-center
          div.mt-3.py-6
            .s1.primary500--text Save the income and expense you
            .s1.primary500--text entered in this walkthrough?
            .p1.basic700--text.mt-4 Only save if you entered real data.
            
            v-card.mx-4.mt-4.py-1
              div.text-center.mt-4
                v-row.d-flex.align-center(no-gutters)
                  v-col.shrink
                    v-btn.my-auto.mr-2(color="primary400" text height=32 x-small disabled)
                      eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="12")
                      .label.ml-n1.basic100--text Filter
                  v-col
                    .s1.primary500--text Profit & Loss
                  v-col.shrink
                    v-btn.my-auto.mr-2(color="primary400" text height=32 x-small disabled)
                      eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="12")
                      .label.ml-n1.primary400--text Filter
                .h5 
                  span.danger500--text(v-if="totalProfitLoss < 0") {{ totalProfitLoss | displayPrice }}
                  span.success500--text(v-else-if="totalProfitLoss > 0") {{ totalProfitLoss | displayPrice }}
                  span(v-else) {{ totalProfitLoss | displayPrice }}
                .c2.textColorHint--text This month
                
              v-card.ma-4.pa-2(flat outlined max-width="480px" style="border: 1px solid var(--v-primary200);")
                v-row(no-gutters)
                  v-col(align="center")
                    .p2.my-1 Income
                    .s1.mb-1 {{ form.income.value | displayPrice }}
                  v-divider.basic300(vertical)
                  v-col(align="center")
                    .p2.my-1 Expense
                    .s1.mb-1 {{ form.expense.value | displayPrice }}
          
          .actions.mb-4
            v-btn.mr-4(color="info500" outlined @click="nextStep()" depressed height=32 width=105 :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") 
              .button-AA-small.info500--text don’t save
            v-btn(color="info500" dark @click="saveData()" depressed height=32 width=105 :loading="isLoading") 
              .button-AA-small.basic100--text Save

</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters, mapActions } from 'vuex'
import CalculatorInput from '@/components/yezzabook/dialogs/CalculatorInput.vue'

export default {
  name: 'WalkThroughSetupDialog',
  props: ['open'],
  components: { CalculatorInput },
  data: vm => ({
    step: 0,
    steps: [
      { title: 'Welcome to Yezza Books!', description: '', color: vm.$vuetify.theme.themes[vm.$theme].basic100, divider: 'basic300', secondary: 'Skip walkthrough', primary: 'Get Started'},
      { title: '1. Record your sales', description: '', color: vm.$vuetify.theme.themes[vm.$theme].basic100, divider: 'basic300', secondary: 'Skip walkthrough', primary: 'Next'},
      { title: 'Try recording a sale', description: 'Fill in the required details in the fields below.', color: vm.$vuetify.theme.themes[vm.$theme].infoT08, divider: 'info100', secondary: 'Back', primary: 'Next'},
      { title: '2. Record your expenses', description: '', color: vm.$vuetify.theme.themes[vm.$theme].basic100, divider: 'basic300', secondary: 'Back', primary: 'Next'},
      { title: 'Try recording an expense', description: 'Fill in the required details. You can record past expenses by changing the date.', color: vm.$vuetify.theme.themes[vm.$theme].primary500, text: 'basic100--text', divider: 'basic100', secondary: 'Back', primary: 'Next'},
      { title: '3. View profit & loss', description: '', color: vm.$vuetify.theme.themes[vm.$theme].basic100, divider: 'basic300', secondary: 'Back', primary: 'Next'},
      { title: 'Congratulations!', description: '', color: vm.$vuetify.theme.themes[vm.$theme].basic100, divider: 'basic300', secondary: 'Back', primary: 'Finish'},
    ],
    openCalculatorInputIncomeDialog: false,
    openCalculatorInputExpenseDialog: false,
    openSaveDialog: false,
    shownSaveDialog: false,
    needReloadPage: false,
    form: { 
      income: { 
        value: 0,
        description: '',
        record_date: null,
        date: {
          show: false,
          value: null
        }
      },
      expense: { 
        value: 0,
        description: '',
        record_date: null,
        date: {
          show: false,
          value: null
        },
        category: null
      }
    },
    isFetchingCategories: true,
    categories: [],
    isLoading: false,
    rules: {
      is_selected: [(v) => v !== null || 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    totalProfitLoss () {
      return this.form.income.value - this.form.expense.value
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.$router.push('/admin/dashboard')
    this.form.income.record_date = DateTime.local().toFormat('yyyy-MM-dd')
    this.form.income.date.value = this.formatDate(this.form.income.record_date)
    this.form.expense.record_date = DateTime.local().toFormat('yyyy-MM-dd')
    this.form.expense.date.value = this.formatDate(this.form.expense.record_date)
    this.fetchCategories()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCategories () {
      this.$axios.get(`/books/${this.company.slug}/expense_categories`)
        .then((response) => {
          this.isFetchingCategories = false
          this.categories = response.data.results
        }).catch(() => {})
    },
    previous () {
      if (this.step === 0 || this.step === 1) {
        this.finish()
        return
      }
      this.step-- 
    },
    nextStep () {
      if (this.step === 2) {
        if (!this.form.income.value || this.form.income.value === '000') {
          this.showMessage(['error', this.$t('error_message.amount_is_required')])
          return
        }
      } 
      else if (this.step === 4) {
        if (!this.form.expense.value || this.form.expense.value === '000') {
          this.showMessage(['error', this.$t('error_message.amount_is_required')])
          return
        }
        if (!this.$refs.form.validate()) {
          return
        }
      }
      else if (this.step === 5 && !this.shownSaveDialog) {
        this.openSaveDialog = true
        this.shownSaveDialog = true
        return
      }
      else if (this.step === (this.steps.length - 1)) {
        this.finish()
        if (this.needReloadPage) {
          location.reload()
        }
        return
      }
      this.openSaveDialog = false
      this.step++
    },
    finish () {
      this.$store.commit('user/setWalkThroughBooks', { step: 0, skipped: true, skippedTs: new Date() })
      this.showModal = false
    },
    handleInputIncome (val) {
      this.form.income.value = (parseFloat(val)).toFixed(this.$currency.exponent).replace('.', '')
    },
    saveIncomeDate () {
      this.form.income.date.show = false
      this.form.income.date.value = this.formatDate(this.form.income.record_date)
    },
    handleInputExpense (val) {
      this.form.expense.value = (parseFloat(val)).toFixed(this.$currency.exponent).replace('.', '')
    },
    saveExpenseDate () {
      this.form.expense.date.show = false
      this.form.expense.date.value = this.formatDate(this.form.expense.record_date)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    saveData () {
      this.openSaveDialog = false
      this.step++
      this.needReloadPage = true
      const income = {
        amount: this.form.income.value,
        quotation: false,
        record_date: this.form.income.record_date,
        description: this.form.income.description
      }
      this.$axios.post(`/books/${this.company.slug}/incomes/`, income)
        .then(resp => {
            const incomePid = resp.data.pid
            this.$axios.post(`/books/${this.company.slug}/incomes/${incomePid}/add_full_payment/`, { payment_method: 'Bank Transfer' })
              .catch(() => {})
          })
          .catch(() => {})

      const expense = {
        items: [{ amount: this.form.expense.value, description: this.form.income.description}],
        category: this.form.expense.category.id,
        record_date: this.form.expense.record_date,
      }
      this.$axios.post(`/books/${this.company.slug}/expenses/`, expense)
        .then(resp => {
            const expensePid = resp.data.id
            this.$axios.post(`/books/${this.company.slug}/expenses/${expensePid}/payments/`, { payment_method: 'Bank Transfer' })
              .catch(() => {})
          })
          .catch(() => {})

    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "product_name": {
      "label": "Product name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    }
  }
}
</i18n>
